import { usePayOS } from '@payos/payos-checkout';
import { notification } from 'antd';
import API from 'API';
import { useMask } from 'App';
import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom';

const cssPayPopup = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    zIndex: -500,
}

function PayPopupComponent({ data, idPopUp }) {
    const { open } = usePayOS(data);
    useEffect(() => {
        open()
        const payIframe = document.querySelector(`#${idPopUp}`).children[0]
        payIframe.height = "100%"
        payIframe.onload = function () {
            notification.info({
                message:<>Bạn có thể dùng <b>App ngân hàng bất kỳ hoặc ví điện tử (Momo, ZaloPay)</b> để quét mã thanh toán!</>,
                placement: "top",
                key: `noti-pay-bank-momo-zalopay-${idPopUp}`,
                duration: 0,
                className: "noti-pay-bank-momo-zalopay",
            })
        }
        // eslint-disable-next-line
    }, [])
}

export default function PayPopup({ checkoutUrl, setCheckoutUrl, setOrders, payingOrder, setPayingOrder }) {
    const [payPopup, setPayPopup] = useState(null);
    const { setFullMask } = useMask();
    const navigate = useNavigate();
    const payOSConfig = useMemo(() => ({
        RETURN_URL: window.location.origin,
        ELEMENT_ID: "embedded-payment-container",
        CHECKOUT_URL: checkoutUrl,
        onSuccess: (event) => {
            setFullMask(true);
            API.post("/student/confirm-pay-order/", { order_id: payingOrder.id })
            .then(res => {
                navigate("/student-courses");
                setCheckoutUrl(null);
                setPayingOrder(null);
                setOrders(orders => {
                    const index = orders.findIndex(item => item.id === payingOrder.id);
                    if (index === -1) return orders;
                    orders[index] = res.data;
                    return [...orders];
                })
                setFullMask(false);
            })
            .catch(error => {
                console.log(error);
            })
        },
        onCancel: (event) => {
            setFullMask(true);
            API.post("/student/cancel-order/", { order_id: payingOrder.id })
            .then(res => {
                setCheckoutUrl(null);
                setPayingOrder(null);
                setOrders(orders => {
                    const index = orders.findIndex(item => item.id === payingOrder.id);
                    if (index === -1) return orders;
                    orders[index] = res.data;
                    return [...orders];
                })
                setFullMask(false);
            })
            .catch(error => {
                console.log(error);
            })
        },
        onExit: (event) => {
            setCheckoutUrl(null);
            setPayingOrder(null);
        }
    }),[checkoutUrl, navigate, payingOrder?.id, setCheckoutUrl, setFullMask, setOrders, setPayingOrder]);

    useEffect(() => {
        if (checkoutUrl) {
            setPayPopup(<PayPopupComponent data={payOSConfig} idPopUp={"embedded-payment-container"} />);
        } else {
            setPayPopup(null);
        }
    },[payOSConfig, checkoutUrl])

    return <>
        {payPopup}
        <div id={"embedded-payment-container"} style={payPopup ? { ...cssPayPopup, zIndex: 2000 } : cssPayPopup} />
    </>
}
